export const ROUND_SUMMARY_OPEN_KEY = 'roundSummaryOpen';

type OpenMap = Record<string, boolean>;

const readMap = (): OpenMap => {
  try {
    const raw = window.localStorage.getItem(ROUND_SUMMARY_OPEN_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      return {};
    }
    const map: OpenMap = {};
    for (const [key, value] of Object.entries(parsed)) {
      if (typeof value === 'boolean') map[key] = value;
    }
    return map;
  } catch {
    return {};
  }
};

export const storedRoundSummaryOpen = (
  roundNumber: number,
): boolean | undefined => {
  const value = readMap()[String(roundNumber)];
  return typeof value === 'boolean' ? value : undefined;
};

export const setRoundSummaryOpen = (roundNumber: number, open: boolean) => {
  try {
    const map = readMap();
    map[String(roundNumber)] = open;
    window.localStorage.setItem(ROUND_SUMMARY_OPEN_KEY, JSON.stringify(map));
  } catch (err) {
    console.error('Error saving round summary open state:', err);
  }
};

export const clearRoundSummaryOpen = () => {
  try {
    window.localStorage.removeItem(ROUND_SUMMARY_OPEN_KEY);
  } catch (err) {
    console.error('Error clearing round summary open state:', err);
  }
};
